import { render, staticRenderFns } from "./HowToVideoList.vue?vue&type=template&id=f8c6079a&"
import script from "./HowToVideoList.vue?vue&type=script&lang=js&"
export * from "./HowToVideoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports